var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 105,
    viewBox: "0 0 1920 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 105,
    fill: "#D2D2D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3576_41652)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1005,
    transform: "translate(0 -900)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3576_41652)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-684 32.3109L-607.62 44.2798C-532.38 56.2487 -379.62 80.1865 -228 72.2072C-76.38 64.228 76.38 24.3316 228 20.3419C379.62 16.3523 532.38 48.2694 607.62 64.228L684 80.1865V152H607.62C532.38 152 379.62 152 228 152C76.38 152 -76.38 152 -228 152C-379.62 152 -532.38 152 -607.62 152H-684V32.3109Z",
    fill: "url(#paint0_linear_3576_41652)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3576_41652)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.3109L107.2 44.2798C212.8 56.2487 427.2 80.1865 640 72.2072C852.8 64.228 1067.2 24.3316 1280 20.3419C1492.8 16.3523 1707.2 48.2694 1812.8 64.228L1920 80.1865V152H1812.8C1707.2 152 1492.8 152 1280 152C1067.2 152 852.8 152 640 152C427.2 152 212.8 152 107.2 152H0V32.3109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.3109L107.2 44.2798C212.8 56.2487 427.2 80.1865 640 72.2072C852.8 64.228 1067.2 24.3316 1280 20.3419C1492.8 16.3523 1707.2 48.2694 1812.8 64.228L1920 80.1865V152H1812.8C1707.2 152 1492.8 152 1280 152C1067.2 152 852.8 152 640 152C427.2 152 212.8 152 107.2 152H0V32.3109Z",
    fill: "url(#paint1_linear_3576_41652)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M763.424 164.473L840.676 167.527C916.795 170.712 1071.3 176.818 1220.98 151.353C1370.66 125.889 1517.78 68.5895 1667.92 47.0878C1818.06 25.5861 1973.48 39.6182 2050.07 46.7661L2127.78 53.7822L2136.09 125.114L2060.22 133.949C1985.48 142.652 1833.75 160.323 1683.15 177.862C1532.54 195.401 1380.81 213.072 1230.21 230.611C1079.61 248.149 927.871 265.82 853.137 274.524L777.269 283.359L763.424 164.473Z",
    fill: "url(#paint2_linear_3576_41652)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3576_41652",
    x: -10,
    y: 15,
    width: 1940,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.203922 0 0 0 0 0.215686 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3576_41652"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.203922 0 0 0 0 0.215686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3576_41652",
    result: "effect2_dropShadow_3576_41652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3576_41652",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3576_41652",
    x1: -684,
    y1: 20,
    x2: -642.773,
    y2: 290.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B40ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#9373F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3576_41652",
    x1: 506,
    y1: -6.99142,
    x2: 511.642,
    y2: 208.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B40ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8077F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3576_41652",
    x1: 762,
    y1: 152.245,
    x2: 834.241,
    y2: 416.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#6B40ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#9373F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3576_41652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1005,
    fill: "white",
    transform: "translate(0 -900)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3576_41652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 105,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingWave);
export default __webpack_public_path__ + "static/media/onboarding-wave.6cffbd05cfc5b36fbb9170e6807ec707.svg";
export { ForwardRef as ReactComponent };